(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["im-calculator"] && !Shopify.designMode) return;
  try {
    
  class ImCalculator extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;

      this.min = Number(d.min) || 300;
      this.max = Number(d.max) || 5000;

      // Tiered terms — identical to improvemint-weekly-price.liquid.
      this.threshold = Number(d.threshold) || 1250;
      this.multBelow = parseFloat(d.multBelow) || 2.3;
      this.termBelow = Number(d.termBelow) || 56;
      this.multAbove = parseFloat(d.multAbove) || 2.4;
      this.termAbove = Number(d.termAbove) || 78;

      this.earlyDays = Number(d.earlyDays) || 110;
      this.earlyMode = d.earlyMode || 'percent';
      this.earlyPercent = Number(d.earlyPercent) || 0;
      this.earlyFee = Number(d.earlyFee) || 0;

      const cur = d.currency || 'USD';
      this.money = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: cur, maximumFractionDigits: 0,
      });
      this.moneyCents = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2,
      });

      this.range = this.querySelector('[data-im-price]');
      this.segs = Array.from(this.querySelectorAll('[data-im-freq]'));
      this.frequency =
        this.segs.find((s) => s.getAttribute('aria-checked') === 'true')?.dataset.imFreq || 'weekly';

      const minEl = this.querySelector('[data-im-min]');
      const maxEl = this.querySelector('[data-im-max]');
      if (minEl) minEl.textContent = this.money.format(this.min);
      if (maxEl) maxEl.textContent = this.money.format(this.max);

      const lbl = this.querySelector('[data-im-early-label]');
      if (lbl) lbl.textContent = `Pay it off in ${this.earlyDays} days`;

      this.range?.addEventListener('input', () => this.render());
      this.segs.forEach((seg) => {
        seg.addEventListener('click', () => {
          this.frequency = seg.dataset.imFreq;
          this.segs.forEach((s) => s.setAttribute('aria-checked', String(s === seg)));
          this.render();
        });
      });

      this.render();
    }

    // Which tier this cash price falls into.
    tier(cash) {
      return cash >= this.threshold
        ? { mult: this.multAbove, weeks: this.termAbove }
        : { mult: this.multBelow, weeks: this.termBelow };
    }

    /*
     * Cadence re-slices the SAME total — it never changes what you pay in
     * aggregate. The lease schedule is weekly, so biweekly and monthly are
     * derived from the weekly term rather than invented.
     */
    slices(weeks) {
      // `cadence` is the adjectival form ("Weekly"), which is what labels the
      // amount. It replaced a prepositional `word` ("per week") when the note
      // was split in two; that form now has no reader, so it is gone rather
      // than left returned-but-unused. Note the two cannot be derived from
      // each other by string surgery — "every 2 weeks" is its own shape.
      if (this.frequency === 'weekly') return { n: weeks, cadence: 'Weekly' };
      if (this.frequency === 'biweekly') return { n: Math.ceil(weeks / 2), cadence: 'Every 2 weeks' };
      return { n: Math.round(weeks / 4.333), cadence: 'Monthly' };
    }

    earlyPayoff(cash) {
      return this.earlyMode === 'fee'
        ? cash + this.earlyFee
        : cash * (1 + this.earlyPercent / 100);
    }

    /*
     * The tier boundary is the one genuinely confusing thing about this
     * pricing: crossing it LOWERS the weekly payment (the term jumps further
     * than the multiplier does) while RAISING the total. Left unexplained it
     * looks broken. So near the boundary we state plainly what changes and
     * what it costs — which is the whole brand argument, applied to our own
     * least flattering number.
     *
     * Returns null when the price is far enough from the boundary that the
     * note would just be noise.
     */
    tierNote(cash) {
      // +/-20% of the threshold: close enough that the switch is worth
      // knowing about, far enough that it isn't noise on every drag.
      /*
       * SILENT AT OR ABOVE THE THRESHOLD. The note used to show on both sides
       * of the boundary, so a shopper who had already crossed it was handed a
       * paragraph about a tier they were no longer in — an explanation for a
       * decision already made. Below the line it is useful: it says what
       * happens if you keep dragging. Above it, the right answer is silence.
       */
      if (cash >= this.threshold) return null;

      // Within 20% BELOW the threshold: close enough that the switch is worth
      // knowing about, far enough that it isn't noise on every drag.
      const band = 0.2;
      if (cash < this.threshold * (1 - band)) return null;

      /*
       * Compare the two tiers at the BOUNDARY, not at the current price.
       * A $1,500 lease can never run the 56-week term, so quoting "what it
       * would cost weekly on the short term" at $1,500 would be a number the
       * customer can never actually get. The honest comparison is the last
       * price on the short term against the first price on the long one.
       */
      const step = Number(this.range?.step) || 50;
      const justBelow = this.threshold - step;

      const belowTotal = justBelow * this.multBelow;
      const belowWeekly = belowTotal / this.termBelow;
      const aboveTotal = this.threshold * this.multAbove;
      const aboveWeekly = aboveTotal / this.termAbove;
      const diff = aboveTotal - belowTotal;

      return (
        `Crossing ${this.money.format(this.threshold)} switches the lease from ` +
        `${this.termBelow} to <b>${this.termAbove} weeks</b>. ` +
        `A ${this.money.format(justBelow)} lease is ` +
        `<b>${this.moneyCents.format(belowWeekly)}/wk</b> and ` +
        `${this.money.format(belowTotal)} in total; a ` +
        `${this.money.format(this.threshold)} lease is ` +
        `<b>${this.moneyCents.format(aboveWeekly)}/wk</b> and ` +
        `${this.money.format(aboveTotal)} — a smaller weekly payment, ` +
        `<b>${this.money.format(diff)}</b> more overall.`
      );
    }

    render() {
      const cash = Number(this.range?.value) || this.min;
      const { mult, weeks } = this.tier(cash);
      const total = cash * mult;
      const { n, cadence } = this.slices(weeks);
      const payment = total / n;
      const early = this.earlyPayoff(cash);
      const months = Math.round(weeks / 4.333);

      const set = (sel, val) => {
        const el = this.querySelector(sel);
        if (el) el.textContent = val;
      };

      set('[data-im-price-out]', this.money.format(cash));
      set('[data-im-payment]', this.moneyCents.format(payment));
      set('[data-im-payment-cadence]', `${cadence} + tax`);
      set('[data-im-payment-note]', `${n} payments over about ${months} months`);
      set('[data-im-total]', this.money.format(total));
      set('[data-im-early]', this.money.format(early));

      /*
       * THE EARLY-PURCHASE HINT IN REAL MONEY, and it has to live in render()
       * rather than beside the other one-time labels in connectedCallback():
       * the uplift is a function of the cash price, so it changes on every
       * drag. Set once at init it read "Cash price plus 10%" forever.
       *
       * A percentage is the rule; a dollar figure is the answer. The
       * calculator already knows the price, so making a shopper compute
       * 1250 x 0.10 in their head is asking them for something we are already
       * holding. Fee mode is unchanged — there the fee already IS the figure,
       * though it now goes through the currency formatter rather than a bare
       * `$${n}`, which printed "$120" as "$120" and "$120.5" as "$120.5".
       */
      const hint = this.querySelector('[data-im-early-hint]');
      if (hint) {
        hint.textContent =
          this.earlyMode === 'fee'
            ? `Cash price plus a ${this.money.format(this.earlyFee)} fee. No penalty.`
            : `Cash price plus ${this.money.format(early - cash)}. No penalty.`;
      }

      const tierEl = this.querySelector('[data-im-tier]');
      if (tierEl) {
        const note = this.tierNote(cash);
        if (note) {
          tierEl.innerHTML = note;
          tierEl.hidden = false;
        } else {
          tierEl.hidden = true;
        }
      }
    }
  }

  if (!customElements.get('im-calculator')) customElements.define('im-calculator', ImCalculator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["im-retailers"] && !Shopify.designMode) return;
  try {
    
  class ImRetailers extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.im-rt__item'));
      this.empty = this.querySelector('[data-im-empty]');
      this.lastTrigger = null;

      // Industry filter
      this.querySelectorAll('[data-im-filter]').forEach((chip) => {
        chip.addEventListener('click', () => {
          const val = chip.dataset.imFilter;
          this.querySelectorAll('[data-im-filter]').forEach((c) =>
            c.setAttribute('aria-pressed', String(c === chip))
          );
          let shown = 0;
          this.items.forEach((li) => {
            const match = val === 'all' || li.dataset.imIndustry === val;
            li.hidden = !match;
            if (match) shown++;
          });
          if (this.empty) this.empty.hidden = shown > 0;
        });
      });

      // Open / close the mini-profile
      this.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-im-open]');
        if (opener) {
          this.lastTrigger = opener;
          this.open(this.querySelector(`[data-im-panel="${opener.dataset.imOpen}"]`));
          return;
        }
        if (e.target.closest('[data-im-close]')) this.closeAll();
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeAll();
      });
    }

    open(panel) {
      if (!panel) return;
      this.closeAll(false);
      panel.hidden = false;
      document.documentElement.classList.add('im-modal-open');
      panel.querySelector('.im-rt__close')?.focus();
    }

    closeAll(restore = true) {
      this.querySelectorAll('[data-im-panel]').forEach((p) => (p.hidden = true));
      document.documentElement.classList.remove('im-modal-open');
      if (restore && this.lastTrigger) {
        this.lastTrigger.focus();
        this.lastTrigger = null;
      }
    }
  }

  if (!customElements.get('im-retailers')) customElements.define('im-retailers', ImRetailers);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["improvemint-product-specs"] && !Shopify.designMode) return;
  try {
    
  /*
   * Highlights card → the matching specifications row.
   *
   * Matching is by spec NAME, case- and whitespace-insensitive, because the two
   * sources are separate: bestbuy_sync.highlights names are not guaranteed to be
   * specs_grouped row names. No match still opens the expander and scrolls to
   * the top of the specifications, which is where the no-JS link goes anyway.
   *
   * One delegated listener on the element, so every card in this section is
   * covered and nothing leaks to another product section on the page.
   */
  class ImSpecSheet extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => this.onClick(event));
    }

    onClick(event) {
      const card = event.target.closest('[data-im-spec-jump]');
      const sheet = this.querySelector('[data-im-spec-sheet]');
      if (!card || !sheet || !this.contains(card)) return;
      event.preventDefault();

      const normalise = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
      const wanted = normalise(card.dataset.imSpecJump);
      const row = Array.from(sheet.querySelectorAll('[data-im-spec-row]')).find(
        (candidate) => normalise(candidate.dataset.imSpecRow) === wanted
      );

      const expander = row ? row.closest('details') : sheet.querySelector('details');
      if (expander) expander.open = true;

      const target = row || sheet;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ block: row ? 'center' : 'start', behavior: reduce ? 'auto' : 'smooth' });

      // Move focus with the view, or a keyboard or screen-reader user is left on
      // the card while the page scrolls away from them. tabindex -1 makes the
      // target focusable without adding it to the tab order.
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });

      if (row) {
        row.classList.remove('is-flash');
        void row.offsetWidth; // restart the animation on a second click
        row.classList.add('is-flash');
      }
    }
  }

  if (!customElements.get('im-spec-sheet')) customElements.define('im-spec-sheet', ImSpecSheet);

  /*
   * Refetch the spec sheet when the shopper changes variant (C4, 2026-09-25).
   *
   * WHY A LISTENER AND NOT product-info.js. This section is rendered outside
   * <product-info> (templates/product.json: `main`, then `ol_specs`), so the
   * re-render product-info.js already performs never reaches it. The title and
   * the model number ride that re-render; the spec sheet needs its own Section
   * Rendering request, which is one extra fetch per variant change and still far
   * cheaper than shipping every variant's sheet in the page.
   *
   * WHY `change` ON input[name="id"] AND NOT `variant:changed`. The
   * `variant:changed` event carries `this.currentVariant`, which product-info.js
   * only assigns on connect and on the product-swap path — never in
   * handleUpdateProductInfo — so on an ordinary variant switch its detail is the
   * PREVIOUS variant. assets/improvemint-pickup.js documents this at length and
   * uses the same hook for the same reason. The form input is authoritative and
   * bubbles.
   *
   * WHY IT SURVIVES ITS OWN REFRESH. The element is re-rendered inside the
   * replaced markup, so the old one disconnects (removing its listener) and the
   * new one connects. No global flag, no duplicate listeners.
   *
   * RACES. A shopper clicking through three variants starts three fetches that
   * can land out of order. Each request carries a token and only the newest one
   * is applied, so the sheet always ends on the variant that is actually
   * selected. A failed fetch leaves the previous sheet standing, which is the
   * same copy the page had a moment ago rather than a blank section.
   */
  class ImSpecRefresh extends HTMLElement {
    connectedCallback() {
      this.token = 0;
      this.onChange = this.onChange.bind(this);
      document.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
    }

    onChange(event) {
      const target = event.target;
      if (!target || target.name !== 'id') return;
      if (!target.closest('form[action*="/cart/add"]')) return;

      // The listener is on `document`, so it also hears a quick-view or a
      // quick-add form for a DIFFERENT product. Acting on one of those would
      // refetch this section with a variant id that is not on this product —
      // Shopify ignores the bad `?variant=` and renders the default, so the
      // correct sheet would be replaced by the primary's. Match the owning
      // <product-info> against this section's product; no match, or no
      // <product-info> at all, means it is not ours.
      const owner = target.closest('product-info');
      if (!owner || owner.dataset.productId !== this.dataset.productId) return;

      this.refresh(target.value);
    }

    async refresh(variantId) {
      const sectionId = this.dataset.sectionId;
      const productUrl = this.dataset.productUrl;
      if (!variantId || !sectionId || !productUrl) return;

      const wrapper = document.getElementById(`shopify-section-${sectionId}`);
      if (!wrapper) return;

      const mine = ++this.token;
      const url = `${productUrl}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(sectionId)}`;

      let html;
      try {
        const response = await fetch(url);
        if (!response.ok) return;
        html = await response.text();
      } catch (e) {
        return; // Leave the sheet that is already on the page.
      }

      // A newer selection started while this was in flight — its answer wins.
      if (mine !== this.token) return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.getElementById(`shopify-section-${sectionId}`);
      if (!fresh) return;
      wrapper.innerHTML = fresh.innerHTML;
    }
  }

  if (!customElements.get('im-spec-refresh')) customElements.define('im-spec-refresh', ImSpecRefresh);

  } catch(e) { console.error(e); }
})();
})();
